var _g, _path, _path2, _linearGradient, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlutterOriginal = function SvgFlutterOriginal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3FB6D3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 64.2L76.3 0h39.4L32.1 83.6zM76.3 128h39.4L81.6 93.9l34.1-34.8H76.3L42.2 93.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27AACD",
    d: "M81.6 93.9l-20-20-19.4 19.6 19.4 19.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#19599A",
    d: "M115.7 128L81.6 93.9l-20 19.2L76.3 128z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "flutter-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 59.365,
    y1: 116.36,
    x2: 86.825,
    y2: 99.399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b4e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1a5497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195a9b"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flutter-original-a)",
    d: "M61.6 113.1l30.8-8.4-10.8-10.8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlutterOriginal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flutter-original.5ff1722c.svg";
export { ForwardRef as ReactComponent };